import { useMemo } from "react";
import { Category } from "../model/model";
import { DefaultSavedSearchService } from "./DefaultSavedSearchService";

export const useSavedSearchService = (category: Category) =>
  useMemo(() => new DefaultSavedSearchService(category), []);
